/**
 * Task EE: payroll upgrade + staff self-service (claims, leave, payslips, bank details, payroll settings).
 * One row per key: [key, English, 中文]; Malay falls back to English. Registered in ../modules.ts.
 */
const ROWS = [
  ["ee.me.title", "Me", "我的"],
  ["ee.me.customers", "My customers", "我负责的顾客"],
  ["ee.me.payslips", "My payslips", "我的工资单"],
  ["ee.me.performance", "My performance", "我的业绩"],
  ["ee.me.claims", "Expense claims", "报销申请"],
  ["ee.me.leave", "Leave", "请假"],
  ["ee.me.bank", "Bank details", "银行资料"],
  ["ee.me.notices", "Notices", "通知"],
  ["ee.me.requests", "Team requests", "员工申请"],
  ["ee.notice.claim_approved", "Your expense claim was approved", "您的报销已批准"],
  ["ee.notice.claim_rejected", "Your expense claim was rejected", "您的报销被拒绝"],
  ["ee.notice.claim_paid", "Your expense claim was paid", "您的报销已支付"],
  ["ee.notice.leave_approved", "Your leave was approved", "您的请假已批准"],
  ["ee.notice.leave_rejected", "Your leave was rejected", "您的请假被拒绝"],
  ["ee.notice.payslip_published", "Your payslip for {period} is ready", "{period} 工资单已发布"],
  ["ee.notice.bank_approved", "Your new bank details were approved", "您的银行资料修改已批准"],
  ["ee.notice.bank_rejected", "Your bank details change was rejected", "您的银行资料修改被拒绝"],
  ["ee.notice.markRead", "Mark all read", "全部标为已读"],
  ["ee.status.pending", "Pending", "待审批"],
  ["ee.status.approved", "Approved", "已批准"],
  ["ee.status.rejected", "Rejected", "已拒绝"],
  ["ee.status.cancelled", "Cancelled", "已取消"],
  ["ee.status.paid", "Paid", "已支付"],
  ["ee.status.all", "All", "全部"],
  ["ee.reason", "Reason", "原因"],
  ["ee.rejectReason", "Reason for rejecting (required)", "拒绝原因（必填）"],
  ["ee.approve", "Approve", "批准"],
  ["ee.reject", "Reject", "拒绝"],
  ["ee.cancelReq", "Cancel request", "取消申请"],
  ["ee.edit", "Edit", "修改"],
  ["ee.save", "Save", "保存"],
  ["ee.submit", "Submit", "提交"],
  ["ee.close", "Close", "关闭"],
  ["ee.add", "Add", "添加"],
  ["ee.remove", "Remove", "删除"],
  ["ee.none", "Nothing here yet.", "暂无记录。"],
  ["ee.staff", "Staff", "员工"],
  ["ee.branch", "Branch", "分店"],
  ["ee.date", "Date", "日期"],
  ["ee.amount", "Amount", "金额"],
  ["ee.from", "From", "从"],
  ["ee.to", "To", "至"],
  ["ee.period", "Period", "期间"],
  ["ee.total", "Total", "合计"],
  ["ee.download", "Download PDF", "下载 PDF"],
  ["ee.share", "Share / download PDF", "分享 / 下载 PDF"],
  ["ee.view", "View", "查看"],
  ["ee.saved", "Saved", "已保存"],
  ["ee.allStaff", "All staff", "全部员工"],
  ["ee.allBranches", "All branches", "全部分店"],
  ["ee.claim.new", "New claim", "新报销"],
  ["ee.claim.date", "Expense date", "消费日期"],
  ["ee.claim.category", "Category", "类别"],
  ["ee.claim.description", "Description", "说明"],
  ["ee.claim.receipts", "Receipt photos (required)", "收据照片（必填）"],
  ["ee.claim.camera", "Take photo", "拍照"],
  ["ee.claim.gallery", "From gallery", "从相册选"],
  ["ee.claim.needReceipt", "Add at least one receipt photo.", "请至少添加一张收据照片。"],
  ["ee.claim.payslip", "Paid with the next payslip", "随下期工资发放"],
  ["ee.claim.separate", "Paid separately", "另行支付"],
  ["ee.claim.paidIn", "Paid in payroll {period}", "已随 {period} 工资发放"],
  ["ee.claim.submitted", "Claim submitted", "报销已提交"],
  ["ee.claim.cancelConfirm", "Cancel this claim?", "确定取消这笔报销？"],
  ["ee.claim.inbox", "Claims", "报销审批"],
  ["ee.claim.bulk", "Approve selected ({n})", "批准所选（{n}）"],
  ["ee.claim.markPaid", "Mark paid", "标记已支付"],
  ["ee.claim.payout", "Approved claims are", "批准后的报销"],
  ["ee.leave.apply", "Apply for leave", "申请请假"],
  ["ee.leave.type", "Leave type", "请假类型"],
  ["ee.leave.part", "Duration", "时长"],
  ["ee.leave.full", "Full day(s)", "全天"],
  ["ee.leave.am", "Half day (AM)", "半天（上午）"],
  ["ee.leave.pm", "Half day (PM)", "半天（下午）"],
  ["ee.leave.start", "Start date", "开始日期"],
  ["ee.leave.end", "End date", "结束日期"],
  ["ee.leave.attachment", "Attachment photo", "附件照片"],
  ["ee.leave.attachmentReq", "Attachment photo (required, e.g. MC)", "附件照片（必填，例如病假单 MC）"],
  ["ee.leave.days", "{n} day(s)", "{n} 天"],
  ["ee.leave.balance", "Balance", "余额"],
  ["ee.leave.left", "{n} left", "剩余 {n} 天"],
  ["ee.leave.used", "used {n}", "已用 {n}"],
  ["ee.leave.pendingN", "pending {n}", "待批 {n}"],
  ["ee.leave.unlimited", "no limit", "不限"],
  ["ee.leave.paid", "Paid", "带薪"],
  ["ee.leave.unpaid", "Unpaid", "无薪"],
  ["ee.leave.submitted", "Leave request submitted", "请假申请已提交"],
  ["ee.leave.inbox", "Leave", "请假审批"],
  ["ee.leave.calendar", "Who is on leave", "请假日历"],
  ["ee.leave.balances", "Balances", "假期余额"],
  ["ee.leave.entitlement", "Entitlement (days)", "年度额度（天）"],
  ["ee.leave.adjust", "Adjustment (days)", "调整（天）"],
  ["ee.leave.carry", "carried {n}", "结转 {n}"],
  ["ee.bank.name", "Bank", "银行"],
  ["ee.bank.other", "Other bank", "其他银行"],
  ["ee.bank.holder", "Account holder name", "户名"],
  ["ee.bank.account", "Account number", "账号"],
  ["ee.bank.none", "No bank details yet. Ask the owner, or request below.", "尚未登记银行资料。请联系老板，或在下方申请。"],
  ["ee.bank.request", "Request a change", "申请修改"],
  ["ee.bank.requested", "Change requested — waiting for the owner", "已申请修改，等待老板审批"],
  ["ee.bank.idNumber", "IC / passport no.", "身份证 / 护照号码"],
  ["ee.bank.employment", "Employment type", "雇佣类型"],
  ["ee.bank.residency", "Residency", "身份"],
  ["ee.bank.birth", "Date of birth", "出生日期"],
  ["ee.bank.title", "Bank details & payroll IDs", "银行资料与薪资编号"],
  ["ee.bank.missing", "Missing bank details", "缺少银行资料"],
  ["ee.bank.ownerOnly", "Full numbers are visible to the owner only.", "完整号码仅老板可见。"],
  ["ee.bank.requests", "Change requests", "修改申请"],
  ["ee.emp.full_time", "Full-time", "全职"],
  ["ee.emp.part_time", "Part-time", "兼职"],
  ["ee.emp.contract", "Contract", "合约"],
  ["ee.emp.intern", "Intern", "实习"],
  ["ee.res.local", "Local", "本地"],
  ["ee.res.foreign", "Foreign worker", "外籍员工"],
  ["ee.slip.earnings", "Earnings", "收入"],
  ["ee.slip.deductions", "Deductions", "扣款"],
  ["ee.slip.reimbursements", "Reimbursements", "报销"],
  ["ee.slip.employer", "Employer contributions (not deducted)", "雇主供款（不从工资扣除）"],
  ["ee.slip.gross", "Gross pay", "总收入"],
  ["ee.slip.net", "Net pay", "实发工资"],
  ["ee.slip.ytd", "Year to date", "本年累计"],
  ["ee.slip.bank", "Paid to", "发放至"],
  ["ee.slip.none", "No payslips yet. They appear here when the owner finalises a payroll month.", "暂无工资单。老板定稿后会显示在这里。"],
  ["ee.slip.basis", "Calculation", "计算方式"],
  ["ee.slip.employerCost", "Total employer cost", "雇主总成本"],
  ["ee.perf.orders", "My orders", "我的订单"],
  ["ee.perf.services", "Services", "服务"],
  ["ee.perf.products", "Products", "产品"],
  ["ee.perf.packages", "Packages", "配套"],
  ["ee.perf.subscriptions", "Subscriptions", "订阅"],
  ["ee.perf.commission", "Commission", "提成"],
  ["ee.perf.myCommission", "My commission", "我的提成"],
  ["ee.perf.customer", "Customer", "顾客"],
  ["ee.perf.walkIn", "Walk-in", "散客"],
  ["ee.perf.order", "Order {label}", "订单 {label}"],
  ["ee.perf.notMine", "(not mine)", "（非本人）"],
  ["ee.cust.visits", "Visits with me", "与我的到访"],
  ["ee.cust.lastVisit", "Last visit", "最近到访"],
  ["ee.cust.spent", "Spent with me", "在我这里消费"],
  ["ee.cust.notes", "Notes", "备注"],
  ["ee.cust.allergies", "Allergies", "过敏"],
  ["ee.cust.history", "Visit history", "到访记录"],
  ["ee.run.detail", "Payslip detail", "工资单明细"],
  ["ee.run.net", "Net", "实发"],
  ["ee.run.deductions", "Deductions", "扣款"],
  ["ee.run.allowances", "Allowances", "津贴"],
  ["ee.run.reimb", "Claims", "报销"],
  ["ee.run.employer", "Employer", "雇主供款"],
  ["ee.run.zip", "All payslips (ZIP)", "全部工资单 (ZIP)"],
  ["ee.run.bankCsv", "Bank transfer CSV", "银行转账 CSV"],
  ["ee.run.statCsv", "Contributions CSV", "法定供款 CSV"],
  ["ee.run.missingBank", "Add bank details before finalising: {names}", "定稿前请补充银行资料：{names}"],
  ["ee.run.manual", "Manual lines", "手动项目"],
  ["ee.run.manualHint", "Amounts entered here are recalculated into this payslip.", "此处输入的金额会重新计入本工资单。"],
  ["ee.run.lateness", "Lateness log", "迟到记录"],
  ["ee.run.attendance", "{days} days attended · {hours} h", "出勤 {days} 天 · {hours} 小时"],
  ["ee.run.ownerCopy", "Employer copy", "公司副本"],
  ["ee.run.staffCopy", "Employee copy", "员工副本"],
  ["ee.run.branchFilter", "Branch", "分店"],
  ["ee.run.warnAttendance", "Some items need attendance (Full plan) and were skipped.", "部分项目需要考勤功能（Full 方案），已跳过。"],
  ["ee.late.late", "Late", "迟到"],
  ["ee.late.early", "Left early", "早退"],
  ["ee.late.absent", "Absent", "缺勤"],
  ["ee.late.excused", "excused (leave)", "已请假免扣"],
  ["ee.late.min", "{n} min", "{n} 分钟"],
  ["ee.late.scheduled", "Scheduled {t}", "应到 {t}"],
  ["ee.late.actual", "Actual {t}", "实际 {t}"],
  ["ee.set.tab", "Payroll settings", "薪资设置"],
  ["ee.set.components", "Allowances & deductions", "津贴与扣款"],
  ["ee.set.lateness", "Lateness rule", "迟到规则"],
  ["ee.set.statutory", "Statutory contributions", "法定供款"],
  ["ee.set.leaveTypes", "Leave types", "请假类型"],
  ["ee.set.general", "General", "通用"],
  ["ee.set.effective", "Effective from", "生效日期"],
  ["ee.set.effectiveHint", "Can start on a past date after the last finalised month ({date}).", "可从最后定稿月份之后的日期开始（{date}）。"],
  ["ee.set.history", "Versions", "历史版本"],
  ["ee.set.current", "current", "当前"],
  ["ee.set.saveVersion", "Save as new version", "保存为新版本"],
  ["ee.set.addEarning", "Add allowance", "添加津贴"],
  ["ee.set.addDeduction", "Add deduction", "添加扣款"],
  ["ee.set.earning", "Allowance / earning", "津贴 / 收入"],
  ["ee.set.deduction", "Deduction", "扣款"],
  ["ee.set.nameEn", "Name (English)", "名称（英文）"],
  ["ee.set.nameZh", "Name (中文)", "名称（中文）"],
  ["ee.set.calc", "Calculation", "计算方式"],
  ["ee.set.taxable", "Taxable", "应税"],
  ["ee.set.statBase", "Counts for statutory wage base", "计入法定供款工资基数"],
  ["ee.set.perfect", "Only with perfect attendance", "仅全勤时发放"],
  ["ee.set.active", "Active", "启用"],
  ["ee.set.applies", "Applies to", "适用于"],
  ["ee.set.scope.all", "All staff", "全部员工"],
  ["ee.set.scope.levels", "Staff levels", "员工级别"],
  ["ee.set.scope.roles", "Roles", "角色"],
  ["ee.set.scope.staff", "Specific staff", "指定员工"],
  ["ee.set.branches", "Branches (empty = all)", "分店（留空=全部）"],
  ["ee.set.needsAttendance", "needs attendance", "需考勤"],
  ["ee.calc.fixed", "Fixed per month", "每月固定"],
  ["ee.calc.per_day", "Per working day attended", "按出勤天数"],
  ["ee.calc.per_hour", "Per hour worked", "按工时"],
  ["ee.calc.percent_sales", "% of sales", "业绩百分比"],
  ["ee.calc.tiered_sales", "Tiered by sales target", "按业绩目标分级"],
  ["ee.calc.manual", "Entered per payslip", "每期手动输入"],
  ["ee.calc.per_late_minute", "Per late minute", "按迟到分钟"],
  ["ee.calc.per_late_occurrence", "Per late occurrence", "按迟到次数"],
  ["ee.calc.per_absent_day", "Per absent day", "按缺勤天数"],
  ["ee.calc.rate", "Amount", "金额"],
  ["ee.calc.bp", "Percent", "百分比"],
  ["ee.calc.base", "Sales base", "业绩基数"],
  ["ee.calc.base.all", "All sales", "总业绩"],
  ["ee.calc.base.service", "Service sales", "服务业绩"],
  ["ee.calc.base.product", "Product sales", "产品业绩"],
  ["ee.calc.tierFrom", "Sales ≥", "业绩 ≥"],
  ["ee.calc.tierPay", "pays", "发放"],
  ["ee.calc.addTier", "Add tier", "添加级别"],
  ["ee.calc.dailyRate", "daily rate (basic ÷ divisor)", "日薪（月薪 ÷ 天数）"],
  ["ee.lt.enabled", "Deduct for lateness", "启用迟到扣款"],
  ["ee.lt.source", "Start time", "上班时间来源"],
  ["ee.lt.useRoster", "Use the roster (staff shifts) when a shift exists, otherwise:", "有排班时以排班为准，否则："],
  ["ee.lt.default", "Default start / end", "默认上下班时间"],
  ["ee.lt.branchTimes", "Per branch", "按分店"],
  ["ee.lt.staffTimes", "Per staff member", "按员工"],
  ["ee.lt.grace", "Grace minutes", "宽限分钟"],
  ["ee.lt.rounding", "Rounding", "取整"],
  ["ee.lt.round.minute", "Per minute", "按分钟"],
  ["ee.lt.round.block15", "Per started 15 min", "每 15 分钟一档"],
  ["ee.lt.penalty", "Penalty", "扣款方式"],
  ["ee.lt.mode.none", "None", "不扣"],
  ["ee.lt.mode.per_minute", "Amount per minute", "每分钟金额"],
  ["ee.lt.mode.per_occurrence", "Amount per occurrence", "每次金额"],
  ["ee.lt.mode.tiered", "Tiered", "分级"],
  ["ee.lt.upTo", "up to (min)", "至（分钟）"],
  ["ee.lt.above", "above", "以上"],
  ["ee.lt.halfDay", "half-day pay", "扣半天"],
  ["ee.lt.cap", "Monthly cap", "每月上限"],
  ["ee.lt.early", "Early leave rule", "早退规则"],
  ["ee.lt.absence", "Deduct for absence (scheduled day, no clock-in, no leave)", "缺勤扣款（排班日未打卡且未请假）"],
  ["ee.lt.attendanceOff", "Lateness uses GPS clock-in data — attendance is part of the Full plan.", "迟到规则使用 GPS 打卡数据，考勤为 Full 方案功能。"],
  ["ee.lt.workdays", "Working days", "工作日"],
  ["ee.lt.dailyRate", "Daily rate divisor", "日薪计算"],
  ["ee.lt.divFixed", "Basic ÷ fixed days", "月薪 ÷ 固定天数"],
  ["ee.lt.divWorking", "Basic ÷ working days of the month", "月薪 ÷ 当月工作日"],
  ["ee.st.disclaimer", "Example templates — verify with your local accountant / the official source. The system does not guarantee rates are correct.", "示例模板 — 请与当地会计/官方核对，系统不保证税率正确"],
  ["ee.st.loadPreset", "Load country preset", "载入国家模板"],
  ["ee.st.presetLoaded", "Preset loaded — review, then save.", "模板已载入，请核对后保存。"],
  ["ee.st.add", "Add contribution", "添加供款项目"],
  ["ee.st.method", "Method", "计算方法"],
  ["ee.st.method.percent", "% of wage", "工资百分比"],
  ["ee.st.method.bracket", "Bracket table", "级距表"],
  ["ee.st.method.fixed", "Fixed amount", "固定金额"],
  ["ee.st.employee", "Employee share", "员工部分"],
  ["ee.st.employer", "Employer share", "雇主部分"],
  ["ee.st.base", "Wage base includes", "工资基数包含"],
  ["ee.st.base.basic", "Basic", "底薪"],
  ["ee.st.base.hourly", "Hourly pay", "时薪"],
  ["ee.st.base.commission", "Commission", "提成"],
  ["ee.st.base.allowances", "Allowances (flagged)", "津贴（已勾选的）"],
  ["ee.st.base.adjustments", "Adjustments", "调整"],
  ["ee.st.floor", "Wage floor (no employee share below)", "工资下限（低于则员工免缴）"],
  ["ee.st.ceiling", "Wage ceiling", "工资上限"],
  ["ee.st.capEe", "Employee cap", "员工上限"],
  ["ee.st.capEr", "Employer cap", "雇主上限"],
  ["ee.st.rounding", "Rounding", "取整"],
  ["ee.st.round.nearest", "Nearest", "四舍五入"],
  ["ee.st.round.up", "Up", "进位"],
  ["ee.st.round.down", "Down", "舍去"],
  ["ee.st.round.none", "None", "不取整"],
  ["ee.st.unit", "to", "到"],
  ["ee.st.ageBands", "Age bands", "年龄段费率"],
  ["ee.st.addBand", "Add age band", "添加年龄段"],
  ["ee.st.age", "Age", "年龄"],
  ["ee.st.brackets", "Bracket table", "级距表"],
  ["ee.st.paste", "Paste CSV: from,to,employee,employer", "粘贴 CSV：起,止,员工,雇主"],
  ["ee.st.import", "Import", "导入"],
  ["ee.st.rows", "{n} rows", "{n} 行"],
  ["ee.st.empTypes", "Employment types (empty = all)", "雇佣类型（留空=全部）"],
  ["ee.st.residency", "Residency (empty = all)", "身份（留空=全部）"],
  ["ee.st.optOut", "Opt-out staff", "不参与的员工"],
  ["ee.st.tax", "Income tax withholding is just another item (bracket table or %) — nothing is computed automatically.", "所得税预扣同样是一个可配置项目（级距表或百分比），系统不会自动计算。"],
  ["ee.st.idFields", "Staff ID fields", "员工证件 / 编号栏位"],
  ["ee.st.idKey", "Key", "代码"],
  ["ee.st.source", "Source", "来源"],
  ["ee.lv.code", "Code", "代码"],
  ["ee.lv.yearly", "Days / year", "每年天数"],
  ["ee.lv.byLevel", "By level", "按级别"],
  ["ee.lv.carry", "Carry-forward cap", "结转上限"],
  ["ee.lv.attach", "Requires attachment", "需附件"],
  ["ee.lv.paid", "Paid", "带薪"],
  ["ee.lv.add", "Add leave type", "添加请假类型"],
  ["ee.gen.claims", "Claims", "报销"],
  ["ee.gen.categories", "Claim categories", "报销类别"],
  ["ee.gen.bankRequired", "Bank details required before finalising", "定稿前必须有银行资料"],
  ["ee.gen.fullOnStaff", "Show the full account number on the staff copy", "员工副本显示完整账号"],
  ["ee.gen.ytd", "Show year-to-date on payslips", "工资单显示本年累计"],
  ["ee.gen.showEmployer", "Show employer contributions on payslips", "工资单显示雇主供款"],
  ["ee.rep.title", "Payroll summary", "薪资汇总"],
  ["ee.rep.csv", "Export CSV", "导出 CSV"],
  ["ee.tab.claims", "Claims", "报销"],
  ["ee.tab.leave", "Leave", "请假"],
  ["ee.tab.bank", "Bank details", "银行资料"],
  ["ee.tab.settings", "Settings", "设置"],
  ["ee.tab.reports", "Reports", "报表"],
  ["ee.tab.lateness", "Lateness", "迟到记录"],
  ["ee.err.receipt_required", "Add at least one receipt photo.", "请至少添加一张收据照片。"],
  ["ee.err.attachment_required", "Attach a photo (e.g. the medical certificate).", "请附上照片（例如病假单）。"],
  ["ee.err.insufficient_balance", "Not enough leave left.", "假期余额不足。"],
  ["ee.err.leave_overlap", "You already have leave on these dates.", "这些日期已有请假。"],
  ["ee.err.bank_details_missing", "Add bank details first.", "请先补充银行资料。"],
  ["ee.pdf.en", "English PDF", "英文 PDF"],
  ["ee.pdf.zh", "Chinese PDF (中文)", "中文 PDF"],
  ["ee.pdf.bilingual", "Bilingual PDF", "双语 PDF"],
  ["ee.pdf.lang", "PDF language", "PDF 语言"],
  ["ee.pdf.default", "Default payslip PDF language", "工资单 PDF 默认语言"],
  ["ee.tier.from", "Sales from", "业绩从"],
  ["ee.tier.to", "to", "到"],
  ["ee.tier.above", "and above", "以上"],
  ["ee.tier.add", "Add tier", "添加阶级"],
  ["ee.tier.remove", "Remove tier", "删除阶级"],
  ["ee.tier.row", "Tier {n}", "第 {n} 级"],
  ["ee.tier.example", "Example", "示例"],
  ["ee.tier.result", "commission", "提成"],
  ["ee.tier.pays", "pays", "发放"],
  ["ee.tier.allAt", "all at {rate}", "全部按 {rate}"],
  ["ee.tier.mode.whole", "Whole amount — the tier reached applies to ALL sales", "整额阶梯 — 达到哪一级，全部业绩按那一级算"],
  ["ee.tier.mode.marginal", "Marginal — each tier only counts the sales inside its range", "超额累进 — 每一级只算该级范围内的业绩"],
  ["ee.tier.tiered", "Tiered", "阶梯"],
  ["ee.tier.err.empty", "Add at least one tier.", "请至少添加一级。"],
  ["ee.tier.err.first_not_zero", "The first tier must start at 0.", "第一级必须从 0 开始。"],
  ["ee.tier.err.not_ascending", "Tier {n}: the amount must be higher than the tier before.", "第 {n} 级：金额必须大于上一级。"],
  ["ee.tier.err.negative", "Tier {n}: values can't be negative (percent at most 100).", "第 {n} 级：数值不能为负（百分比最多 100）。"],
  ["ee.tier.err.too_many", "Up to 10 tiers.", "最多 10 级。"],
  ["ee.tier.err.fix", "Fix the tier tables before saving.", "请先修正阶梯表再保存。"],
] as const;

export type EeKey = (typeof ROWS)[number][0];
const col = (i: 1 | 2) => Object.fromEntries(ROWS.map((r) => [r[0], r[i]])) as Record<EeKey, string>;

export const taskEE = { en: col(1), zh: col(2), ms: col(1) };
